import { render, staticRenderFns } from "./moduleList.vue?vue&type=template&id=614e64e5&"
import script from "./moduleList.vue?vue&type=script&lang=js&"
export * from "./moduleList.vue?vue&type=script&lang=js&"
import style0 from "./moduleList.vue?vue&type=style&index=0&id=614e64e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports